import type {RouteLocationNormalized} from 'vue-router';

export const KNOWN_STEPS = ['PROMPT_PAGE', 'SUMMARY_PAGE', 'SELECTION_PAGE', 'CALIBRATION_PAGE', 'CHECKOUT_PAGE'] as const;
export type KnownStep = (typeof KNOWN_STEPS)[number];
export type StepName = KnownStep | string;

export function resolveStepFromRoute(route: RouteLocationNormalized): StepName | undefined {
    const routeName = typeof route?.name === 'string' ? route.name : String(route?.name ?? '');
    const stepParam = route?.params?.step?.toString();

    if (!stepParam && routeName === 's-advanced') return 'PROMPT_PAGE';
    if (stepParam === 'criteria') return 'SUMMARY_PAGE';

    if (stepParam) {
        return `${stepParam.toUpperCase()}_PAGE`;
    }
    return undefined;
}
